export const stringToDuskAttribute = (value: string | undefined): string =>
  value?.toLowerCase()
    .replaceAll('(', '')
    .replaceAll(')', '')
    .replaceAll(' ', '-') || '';
